module.exports = __webpack_public_path__ + "img/Frame1.3b2e613a.png";